import React from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";

const Input = React.forwardRef(
  ({ label, type = "text", maxLength = 50, error, ...rest }, ref) => {
    const inputClass = classNames(
      "appearance-none outline-none w-full mb-0 text-gray-800 truncate px-4 py-2 pr-10 rounded-theme border-gray-200 border shadow-sm focus:ring-1 focus:ring-accent invalid:ring-red-500",
      {
        "ring-1": error,
        "ring-red-500": error,
      }
    );
    if (type === "hidden") {
      return <input className={inputClass} type={type} {...rest} ref={ref} />;
    }
    return (
      <div className="relative">
        <label
          className="block text-sm font-medium text-gray-700"
          htmlFor={rest.name}
        >
          {label}
          {rest.required && <span className={"ml-1 text-red-500"}>*</span>}
        </label>
        <div className="mt-1 relative">
          <input
            className={inputClass}
            type={type}
            maxLength={maxLength}
            ref={ref}
            {...rest}
            aria-invalid={error ? "true" : "false"}
          />
          {error && typeof error === "string" && (
            <span
              className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              role="alert"
            >
              {error}
            </span>
          )}
          {error && error.type === "required" && (
            <span
              className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              role="alert"
            >
              {label} is required.
            </span>
          )}
          {error && error.type === "maxLength" && (
            <span
              className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              role="alert"
            >
              Max length exceeded
            </span>
          )}
          {error && error.type === "pattern" && (
            <span
              className="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1"
              role="alert"
            >
              {error.message}
            </span>
          )}
        </div>
      </div>
    );
  }
);

Input.propTypes = {
  error: PropTypes.object,
  placeholder: PropTypes.string,
  title: PropTypes.string,
  pattern: PropTypes.string,
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  maxLength: PropTypes.number,
};

Input.displayName = "Input";

export default Input;
